
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#21245c"}}),_c('path',{attrs:{"d":"M15.586 18.106H7.55a1.6 1.6 0 01-1.593-1.594v-3.934a1.6 1.6 0 011.593-1.594h1.381l2.124-4.78a.471.471 0 01.43-.278 2.156 2.156 0 012.154 2.155V9.86h2.713a1.858 1.858 0 01.252.019 1.6 1.6 0 011.335 1.814l-.775 5.059a1.606 1.606 0 01-1.578 1.354zm-5.884-.939h5.9a.661.661 0 00.634-.556l.774-5.058a.646.646 0 00-.121-.486.654.654 0 00-.428-.26.56.56 0 00-.068 0h-3.225a.469.469 0 01-.468-.469V8.086a1.217 1.217 0 00-.928-1.182l-2.069 4.654zm-2.155-5.245a.656.656 0 00-.655.656v3.934a.655.655 0 00.655.655h1.218v-5.245z","fill":"#fff"}})])
          )
        }
      }
    